import { Card, CardContent, Link, Stack, Typography } from '@mui/material'
import { Icons } from 'utoniq-ui'

import { ArtistGachaDetailFragment, Maybe } from '@/clients/utoniq-core/schema'
import { useRouter, useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

type DeactivationMemberCellProps = {
  artistId: string
  artist: Maybe<ArtistGachaDetailFragment>
  type: 'planOnly' | 'allMembership'
  productTitle?: string | null
}

export const DeactivationMemberCell: Cell<DeactivationMemberCellProps> = ({
  artistId,
  artist,
  type,
  productTitle,
}) => {
  const { t } = useTranslation('gachaDetail')
  const { generatePath, routerPages } = useRouter()

  return (
    <CellFrame sx={{ px: 5, pt: 5 }}>
      <Card elevation={0}>
        <CardContent sx={{ p: 3, '&:last-child': { pb: 3 } }}>
          <Stack spacing={2}>
            <Stack direction="row" alignItems="center" spacing={1}>
              <Icons.Info fontSize="small" sx={{ color: 'primary.main' }} />
              <Typography variant="subtitle1" color="primary.main">
                {t(`${type}Title`)}
              </Typography>
            </Stack>
            <Typography variant="caption">
              {t(`${type}Desc`, {
                displayName: artist?.displayName,
                planName: productTitle,
              })}
            </Typography>
            <Stack alignItems="flex-end">
              <Link
                variant="caption"
                href={generatePath(routerPages.ArtistMembership, { artistId })}
              >
                {t('membershipDetail', '詳しく見る')}
              </Link>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </CellFrame>
  )
}
